import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse, AxiosError } from 'axios';
import { STORE_DASHBOARD, STORE_DASHBOARD_LIVECOUNT, STORE_DASHBOARD_COMPLETEDORDER, STORE_DASHBOARD_ONHOLD, STORE_DASHBOARD_RETURNED, STORE_CHART, DataItem, STORE_LARGEST_NUMBER } from 'src/reducers/dashboard';
// import {
//     STORE_ERROR_MESSAGE,
//     STORE_ERROR_BAR
// } from '../reducers/errors';

export const getLiveOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const sessionid = getState().user.userDetails.s || '';
    await axios({
        method: 'post',
        url: `${getState().environment.API_URL}getDashboardSnapshot?userName=${encodeURIComponent(getState().user.userDetails.userName)}`,
        headers: {
            sessionid: sessionid || ''
        },
    }).then(function (response: AxiosResponse) {

        const userOrderdata = response.data[0];
        dispatch({ type: STORE_DASHBOARD, userOrderdata } as AnyAction);

        const total = getState().UserOrderData.userOrderdata.total;
        const completed = getState().UserOrderData.userOrderdata.completed;
        const onhold = getState().UserOrderData.userOrderdata.onhold;
        const returned = getState().UserOrderData.userOrderdata.returned;

        dispatch({ type: STORE_DASHBOARD_LIVECOUNT, total } as AnyAction);
        dispatch({ type: STORE_DASHBOARD_COMPLETEDORDER, completed } as AnyAction);
        dispatch({ type: STORE_DASHBOARD_ONHOLD, onhold } as AnyAction);
        dispatch({ type: STORE_DASHBOARD_RETURNED, returned } as AnyAction);

    }).catch(function (error: AxiosError) {

        // const errorBar = true;
        // const errorMessage = error.message;
        // dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
        // dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
        // ==> console.error(error, 'widget error');
        const total = '0';
        const completed = '0';
        const onhold = '0';
        const returned = '0';

        dispatch({ type: STORE_DASHBOARD_LIVECOUNT, total } as AnyAction);
        dispatch({ type: STORE_DASHBOARD_COMPLETEDORDER, completed } as AnyAction);
        dispatch({ type: STORE_DASHBOARD_ONHOLD, onhold } as AnyAction);
        dispatch({ type: STORE_DASHBOARD_RETURNED, returned } as AnyAction);
    });
};

export const getChart = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const sessionid = getState().user.userDetails.s || '';
    await axios({
        method: 'post',
        url: `${getState().environment.API_URL}getDashBoardTatTrend?userName=${encodeURIComponent(getState().user.userDetails.userName)}`,
        headers: {
            sessionid: sessionid || ''
        },
    }).then(function (response: AxiosResponse) {
        const items: DataItem[] = response.data;

        const maxIntat = Math.max.apply(Math, items.map((item: DataItem) => { return item.intat; }));
        const maxCompleted = Math.max.apply(Math, items.map((item: DataItem) => { return item.completed; }));

        if (maxIntat > maxCompleted) {
            const greatest = 'intat';
            dispatch({ type: STORE_LARGEST_NUMBER, greatest } as AnyAction);
        } else {
            const greatest = 'completed';
            dispatch({ type: STORE_LARGEST_NUMBER, greatest } as AnyAction);
        }
        // const intatValue = items.map(fu)
        // const intat = response.data.intat;
        // const completed = response.data.completed;
        // const greatest = intat > completed ? 
        // dispatch({ type: STORE_LARGEST_NUMBER, greatest } as AnyAction);
        dispatch({ type: STORE_CHART, items } as AnyAction);

    }).catch(function (error: AxiosError) {
        // ==> console.error(error, 'widget error');
        // const errorBar = true;
        // const errorMessage = error.message;
        // dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
        // dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
        const items: DataItem[] = [];
        dispatch({ type: STORE_CHART, items } as AnyAction);

    });

};

export const tutorialVideo = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const formElement = document.createElement('form');
    formElement.style.display = 'none';
    formElement.action = `${getState().environment.DESIGNER_PORTAL_URL}tutorials`;
    formElement.method = 'POST';
    formElement.target = '_blank';
    formElement.id = 'tutorialPage';
    const element = document.createElement('input');
    element.setAttribute('value', 'dsvkdgsLGsdjhadbv');
    element.setAttribute('name', 'secretKeyTutorial');
    formElement.appendChild(element);
    document.body.appendChild(formElement);
    formElement.submit();

    return true;
};



// WEBPACK FOOTER //
// ./src/actions/dashboardAction.ts